var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapsPinDidntBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51567 3.94954C1.92457 5.64764 0.927966 8.12129 0.966664 10.448C1.04747 15.3102 3.2391 17.1508 6.74392 23.8426C8.00642 26.7873 9.3241 29.9032 10.5773 35.0637C10.7515 35.8249 10.9213 36.532 10.9999 36.5933C11.0784 36.6546 11.2483 35.945 11.4225 35.1838C12.6757 30.0232 13.9934 26.9099 15.2559 23.9652C18.7607 17.2733 20.9523 15.4327 21.0332 10.5705C21.0719 8.24379 20.0728 5.76766 18.4817 4.06956C16.6641 2.12977 13.9226 0.694173 10.9999 0.634142C8.07718 0.574072 5.33324 2.00974 3.51567 3.94954Z",
    fill: "#EA912B",
    stroke: "#74430B",
    strokeWidth: 1.26462
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 14.4675C13.12 14.4675 14.8387 12.7489 14.8387 10.6288C14.8387 8.50867 13.12 6.79001 10.9999 6.79001C8.87984 6.79001 7.16113 8.50867 7.16113 10.6288C7.16113 12.7489 8.87984 14.4675 10.9999 14.4675Z",
    fill: "#74430B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 37.2185,
    fill: "white",
    transform: "translate(0.333252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsPinDidntBook);
export default __webpack_public_path__ + "static/media/maps-pin-DidntBook.8d5a821890e200213c74646405462f5f.svg";
export { ForwardRef as ReactComponent };